var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 30,
    viewBox: "0 0 210 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 28V8.5H105V14H99V15.5H105V21H99V23H105V28H92Z",
    fill: "#DF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 28.5V8.5H115L121 19V8.5H128V28.5H121L115 18.5V28.5H108Z",
    fill: "#DF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151 13.5L144.5 15.5C143.541 14.9522 142.998 14.7035 142.284 14.4997C137.5 14 137.304 17.9281 137.5 19.4997C138 23.5 142.5 22.9997 144 21.4997H140.5V16.5181H151.784C152.5 22 150.746 23.6881 149 25.5C143.175 31.5456 134.5 29 131.5 23.9999C127 14 133.716 7.48179 142 7.99999C149 9 150 11.5 151 13.5Z",
    fill: "#DF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M191.5 28.5V8.5H198.5V15H203V8.5H210V28.5H203V21.5H198.5V28.5H191.5Z",
    fill: "#DF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 29C43.0751 29 48 24.299 48 18.5C48 12.701 43.0751 8 37 8C30.9249 8 26 12.701 26 18.5C26 24.299 30.9249 29 37 29ZM37 23C39.2091 23 41 21.2091 41 19C41 16.7909 39.2091 15 37 15C34.7909 15 33 16.7909 33 19C33 21.2091 34.7909 23 37 23Z",
    fill: "#DF0000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 35,
    height: 7,
    fill: "#DF0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 7,
    width: 22,
    height: 7,
    transform: "rotate(90 21 7)",
    fill: "#DF0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154 8H162V28H154V8Z",
    fill: "#DF0000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164 8H171V19H164V8Z",
    fill: "#DF0000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172 22V28H154V22H172Z",
    fill: "#DF0000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M171 3.5C171 5.433 169.433 7 167.5 7C165.567 7 164 5.433 164 3.5C164 1.567 165.567 0 167.5 0C169.433 0 171 1.567 171 3.5Z",
    fill: "#DF0000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M181 28.4127C178.2 28.4127 174.5 27.0794 173 26.4127L175.5 20.9127C177 22.4127 180 22.9126 181 22.9126C181.8 22.9126 182 22.246 182 21.9127C182 21.5794 181.8 20.9127 181 20.9126C175 20.4126 174 17.4126 174 14.9127C174 12.4128 176 9.41273 180 8.41273C184.8 7.21273 188 8.91273 189 9.91273L186.5 14.9127C185.5 14.2461 183.2 13.0127 182 13.4127C180.5 13.9127 181 15.4127 182 15.4127C185 15.9127 189.5 17.4127 189.5 21.9127C189 26.9127 184.5 28.4127 181 28.4127Z",
    fill: "#DF0000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28.4127C53.2 28.4127 49.5 27.0794 48 26.4127L50.5 20.9127C52 22.4127 55 22.9126 56 22.9126C56.8 22.9126 57 22.246 57 21.9127C57 21.5794 56.8 20.9127 56 20.9126C50 20.4126 49 17.4126 49 14.9127C49 12.4128 51 9.41273 55 8.41273C59.8 7.21273 63 8.91273 64 9.91273L61.5 14.9127C60.5 14.2461 58.2 13.0127 57 13.4127C55.5 13.9127 56 15.4127 57 15.4127C60 15.9127 64.5 17.4127 64.5 21.9127C64 26.9127 59.5 28.4127 56 28.4127Z",
    fill: "#DF0000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73 28.4127C70.2 28.4127 66.5 27.0794 65 26.4127L67.5 20.9127C69 22.4127 72 22.9126 73 22.9126C73.8 22.9126 74 22.246 74 21.9127C74 21.5794 73.8 20.9127 73 20.9126C67 20.4126 66 17.4126 66 14.9127C66 12.4128 68 9.41273 72 8.41273C76.8 7.21273 80 8.91273 81 9.91273L78.5 14.9127C77.5 14.2461 75.2 13.0127 74 13.4127C72.5 13.9127 73 15.4127 74 15.4127C77 15.9127 81.5 17.4127 81.5 21.9127C81 26.9127 76.5 28.4127 73 28.4127Z",
    fill: "#DF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d04864683b30e3411ca69babadfa7496.svg";
export { ForwardRef as ReactComponent };